<template>
  <div>
    <div class="tabs">
      <ul>
        <li
          v-for="(tab, i) in tabs"
          :key="i"
          :class="{ 'is-active': tab.isActive }"
        >
          <a :href="tab.href" @click="selectTab(tab)">{{
            tab.name.replaceAll("-", " ")
          }}</a>
        </li>
      </ul>
    </div>
    <div class="tabs-details">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "TABS",
  data() {
    return { tabs: [] };
  },

  created() {
    this.tabs = this.$children;
  },
  mounted() {
    this.routerActiveTab();
  },
  watch: {
    $route() {
      this.routerActiveTab();
    },
  },
  methods: {
    selectTab(selectedTab) {
      this.$emit("name", selectedTab.name);
      this.tabs.forEach((tab) => {
        tab.isActive = tab.name == selectedTab.name;
      });
    },

    routerActiveTab() {
      const routeName =
        this.$route.hash.split("#")[1] || this.$route.params.folder || "";
      if (routeName) {
        this.$emit("name", routeName);
        this.tabs.forEach((tab) => {
          tab.isActive = tab.name == routeName;
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
ul {
  list-style-type: none;
  margin: 0;

  padding: 0 44px;
  @media (min-width: 900px) {
    padding: 0 140px;
  }
  @media (min-width: 1024px) {
    padding: 0 220px;
  }
  @media (min-width: 1900px) {
    padding: 0 470px;
  }

  overflow: hidden;
  border-bottom: 1px solid #e7e7e7;
  display: flex;
  align-items: stretch;
  flex-direction: column;

  @media (min-width: 900px) {
    flex-direction: row;
    gap: 40px;
  }
}
li {
  color: var(--text-normal-color);
  align-items: center;
  display: flex;
  font-weight: 400;
}

@media (min-width: 900px) {
  li:nth-child(4) {
    max-width: 119px;
  }
  li:nth-child(3) {
    max-width: 94px;
  }
}

li a {
  display: block;
  color: inherit;
  text-decoration: none;
  padding: 20px 0;
  text-transform: capitalize;
}

li:hover li::before {
  position: absolute;
  content: "";
  width: 100%;
  height: 5px;

  background: var(--primary-color);
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);

  border-radius: 50px;
  visibility: visible;
  opacity: 1;
  transition: all 0.3s ease;
}
.is-active {
  font-weight: 500;
  color: var(--primary-color) !important;
  position: relative;
}

.is-active::before {
  position: absolute;
  content: "";
  width: 100%;
  height: 5px;

  background: var(--primary-color);
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);

  border-radius: 50px;
  visibility: visible;
  opacity: 1;
  transition: all 0.3s ease;
}
</style>

